import {useEffect, useMemo, useState} from 'react';
import {selfcareCommunications} from "../../util/request";
import {Communication, Pagination} from "../../util/types";
import Icon from "./Icon";
import {PaginationElement} from "./PaginationElement";
import {LocationAwareLink} from "./LocationAwareLink";
import {formatDateTime} from "../../util/formatter";
import LoaderSpinner from '../loaders/LoaderSpinner';
import Routing from "../../Routing.ts";
import IconSmartphoneClassic from "../icons/IconSmartphoneClassic.tsx";
import IconMail from "../icons/IconMail.tsx";

export default function CommunicationTable(props: { customer_id: string, page: number }) {
    const [communications, setCommunications] = useState<Communication[] | null>(null)
    const [pagination, setPagination] = useState<Pagination | null>(null)
    const [loading, setLoading] = useState<boolean>(false);
    const loadingClass: string = loading ? " selfcare-loading-content" : "";

    useEffect(() => {
        setLoading(true)
        selfcareCommunications(props.customer_id, props.page).then(r => {
            setCommunications(r.response.data)
            setPagination(r.response.pagination)
            setLoading(false)
        })
    }, [props.customer_id, props.page])

    const communicationRequests = useMemo(() => {
        if (communications === null) {
            return null;
        }
        return communications;
    }, [communications]);

    if (pagination === null) {
        return <LoaderSpinner/>
    }

    if (pagination === undefined || pagination.total_records === 0) {
        return <p className='no-content'>Der er ingen breve eller SMS'er at vise.</p>
    }

    return <>
        <ol className={`selfcare-communication-overview${loadingClass}`}>
            {communicationRequests?.map((communication) => {
                return (
                    <li key={communication.request_id}>
                        <LocationAwareLink to={Routing.Selfcare.Letters + "/vis/" + communication.request_id}>
                            <CommunicationTypeIcon communication={communication}/>
                            <span className={'text'}>
                            <CommunicationElement communication={communication}/></span>
                        </LocationAwareLink>
                    </li>
                )
            })}
        </ol>
        <PaginationElement pagination={pagination}/>
    </>
}

function CommunicationTypeIcon(props: { communication: Communication }) {

    if (props.communication.channel === 'SMS') {
        return <Icon component={IconSmartphoneClassic}/>
    }

    return <Icon component={IconMail}/>
}

function CommunicationElement(props: { communication: Communication }) {
    return <>
        <span className={"subject"}>{props.communication.subject}</span>
        {props.communication.sent_dtm &&
            <span className={"date"}>{formatDateTime(props.communication.sent_dtm)}</span>
        }
    </>
}
